export type quoteFileType = {
    id: number,
    filename: string
}

export type RequestItemType = {
    request_id: number,
    id: number,
    name: string,
    price: number,
    price_nzd: number,
    currency: string,
    url: string,
    is_gst_included: number,
    supplier: string,
    supplierPartNo: string,
    with_quote: number,
    quote: quoteFileType
}

export const initialRequestItem: RequestItemType = {
    request_id: 0,
    id: 0, // Replace with appropriate default value
    name: "", // Default string value
    price: 0, // Default number value
    price_nzd: 0, // Default number value
    currency: "", // Default string value
    url: "", // Default string value
    is_gst_included: 0, // Default number value
    supplier: "", // Default string value
    supplierPartNo: "", // Default string value
    with_quote: 0, // Default number value
    quote: {
        id: 0, // Default number value for quote
        filename: "", // Default string value for filename
    },
};